import { Component } from '@angular/core';

@Component({
  selector: 'pdf-error-message',
  templateUrl: './pdf-error-message.component.html',
})
export class PdfErrorMessageComponent {}
